import { noop } from "lodash";
import { createContext, useContext, useState } from "react";

export const ProductsContext = createContext({
  products: {},
  setProducts: noop,
  categories: [],
  setCategories: noop,
  textCategories: [],
});

export function ProductsProvider({ children }) {
  const [products, setProducts] = useState({});
  const [categories, setCategories] = useState([]);

  return (
    <ProductsContext.Provider
      value={{
        products,
        setProducts: (contextProducts) =>
          setProducts({ ...products, ...contextProducts }),
        categories: categories
          ?.filter((x) => x.id !== "1")
          ?.sort((x, y) => x.id - y.id),
        setCategories: (contextCategories) => setCategories(contextCategories),
        textCategories: categories
          ?.filter((x) => x.id !== "1")
          ?.sort((x, y) => x.id - y.id)
          ?.map((cat) => cat.name),
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  return useContext(ProductsContext);
}
